import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('theProduct.HighlightsA');
    return (
        <>
            <EfImg
                pc="https://websiteoss.ecoflow.com/upload/image/1724561232037/high_light_4.jpg"
                pad="https://websiteoss.ecoflow.com/upload/image/1724561232037/high_light_4.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1724569212589/high_light_4_h5.jpg"
            />
            <div className="card-box card-box-white card-box-4">
                <div className="card-title">{t('item4_title')}</div>
                <div className="card-desc">{t('item4_desc')}</div>
            </div>
        </>
    );
}
